package com.wintermar.inspection.core.ui.widget.table_container

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.util.modifier.borderExceptTop

@Composable
fun ItemTableContainer(
    onClick: () -> Unit,
    content: @Composable RowScope.() -> Unit
) {
    val dimension = LocalAppTheme.current.dimension
    val color = LocalAppTheme.current.color

    Row(
        modifier = Modifier
            .padding(horizontal = dimension.spacing.space4)
            .fillMaxWidth()
            .background(color.surface.normal)
            .borderExceptTop(
                color = color.border.subtle
            )
            .clickable {
                onClick()
            }
            .padding(dimension.spacing.space4),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(
            dimension.spacing.space1
        )
    ) {
        content()
    }
}
